import { datadogRum } from '@datadog/browser-rum';
import { ReactEventHandler, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useIsMobile } from '~/context/common/DeviceContext';
import { getVehicleDetails } from '~/selectors';
import { logError } from '~/utilities/errorHandlers';

export default function FallbackImage() {
  const {
    stockImageData: { jellyBeanMobileUrl = '', jellyBeanDesktopUrl = '' } = {}
  } = useSelector(getVehicleDetails);
  const isMobile = useIsMobile();
  const [imageFailed, setImageFailed] = useState(false);

  const handleOnError: ReactEventHandler<HTMLImageElement> = e => {
    setImageFailed(true);
    logError('Gallery Jellybean Image Error', {
      imageUrl: e.currentTarget.src
    });
  };

  const imageSrc = isMobile ? jellyBeanMobileUrl : jellyBeanDesktopUrl;

  useEffect(() => {
    datadogRum.addAction('fallback-image-loaded');
  }, []);

  return imageFailed ? null : (
    <div className="flex justify-center">
      <img
        className="w-full max-w-[900px]"
        src={imageSrc}
        alt="Vehicle"
        onError={handleOnError}
      />
    </div>
  );
}
